/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ChangeOptions, Change } from '@typescript-kit/core';
import { Entity, EntityData, EntityFieldKey, EntityModel } from '@typescript-kit/data';

export class EmployeeFieldKey extends EntityFieldKey {
  static readonly COMPANY_ID = 'companyId';
  static readonly ID = 'id';
  static readonly NAME = 'name';
  static readonly IS_ACTIVE = 'isActive';
}

export interface EmployeeData extends EntityData {
  companyId?: string;
  id?: string;
  name?: string;
  isActive?: boolean;
}

export class Employee extends Entity implements EmployeeData {
  readonly companyId: string;
  readonly id: string;
  readonly name: string;
  readonly isActive: boolean;

  constructor(data: EmployeeData) {
    super(data);
    this.id = data.id;
    this.companyId = data.companyId;
    this.name = data.name;
    this.isActive = data.isActive;
  }
}

export class EmployeeModel extends EntityModel implements EmployeeData {
  static readonly KEYS = EntityModel.KEYS.concat(
    Object.keys(EmployeeFieldKey).map(key => EmployeeFieldKey[key])
  );

  constructor(data: EmployeeData) {
    super(data, EmployeeModel.KEYS);
  }

  get companyId(): string {
    return this.get(EmployeeFieldKey.COMPANY_ID);
  }

  get id(): string {
    return this.get(EmployeeFieldKey.ID);
  }

  set id(value: string) {
    this.set(EmployeeFieldKey.ID, value);
  }

  get name(): string {
    return this.get(EmployeeFieldKey.NAME);
  }

  set name(value: string) {
    this.set(EmployeeFieldKey.NAME, value);
  }

  get isActive(): boolean {
    return this.get(EmployeeFieldKey.IS_ACTIVE);
  }

  set isActive(value: boolean) {
    this.set(EmployeeFieldKey.IS_ACTIVE, value);
  }

  setValues(values: EmployeeData, options?: ChangeOptions): { [p: string]: Change<any> } {
    return super.setValues(values, options);
  }
}
